import { memo } from 'react';
import {
    createBrowserRouter,
    Navigate,
    RouterProvider,
} from 'react-router-dom';

import * as Sentry from '@sentry/react';
import type { RouteObject } from '@sentry/react/build/types/types';

import * as route from '@/shared/constants/router';

import { ErrorBoundaryProvider } from '../../error-boundary';
import { ROUTER_CONFIG } from '../config/router-config';

import { AuthRootElement } from './auth-root-element';
import { OnboardingRootElement } from './onboarding-root-element';
import { PrivateRootElement } from './private-root-element';

const sentryCreateBrowserRouter =
    Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

const routesConfig: RouteObject[] = [
    {
        path: route.getMainPath(),
        element: (
            <ErrorBoundaryProvider>
                <AuthRootElement />
            </ErrorBoundaryProvider>
        ),
        children: Object.values(ROUTER_CONFIG.authRoutes),
    },
    {
        path: route.getMainPath(),
        element: (
            <ErrorBoundaryProvider>
                <OnboardingRootElement />
            </ErrorBoundaryProvider>
        ),
        children: Object.values(ROUTER_CONFIG.onboardingRoutes),
    },
    {
        path: route.getMainPath(),
        element: (
            <ErrorBoundaryProvider>
                <PrivateRootElement />
            </ErrorBoundaryProvider>
        ),
        children: [
            ...Object.values(ROUTER_CONFIG.privateRoutes),
            ...Object.values(ROUTER_CONFIG.auxiliaryRoutes),
        ],
    },
    {
        path: '*',
        element: (
            <Navigate
                replace
                to={route.getNotFoundPath()}
            />
        ),
    },
];

const routes = sentryCreateBrowserRouter(routesConfig);

export const AppRouter = memo(() => <RouterProvider router={routes} />);

AppRouter.displayName = 'AppRouter';
